module.exports = __webpack_public_path__ + "img/jeep.a437332b.png";